<template>
  <section id="portfolio">
    <div>
      <h4
        style="
          font-size: 30px;
          font-family: 'Poppins', sans-serif;
          padding: 0px;
        "
      >
        My
        <span style="color: #42b983">Portfolio</span>
      </h4>
      <Carousel
        :autoplay="autoplay"
        :pauseAutoplayOnHover="true"
        :itemsToShow="show"
        :wrapAround="true"
        :transition="transition"
      >
        <Slide v-for="project in projects" :key="project">
          <CardProject
            :image="project.image"
            :title="project.title"
            :description="project.description"
            :link="project.link"
            :stack="project.stack"
            :github="project.github"
          />
        </Slide>

        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import CardProject from "./CardProject.vue";
import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "ProjectsComponent",
  data() {
    return {
      show: 3,
      autoplay: 50,
      transition: "4000",
      projects: [
        {
          title: "New Horizons",
          description: "Website of a software development company.",
          image: "newhorizons.png",
          link: "https://nhsolutions.netlify.app/",
          github: "https://github.com/NewHorizonsSolutions",
          stack: ["mdi-vuejs", "mdi-nodejs", "mdi-database-check-outline"],
        },
        {
          title: "Agenddo",
          description: "Lead software engineer for a brand new startup.",
          image: "agenddo.jpeg",
          link: "https://agenddo.com/",
          github: "https://github.com/AgenddoApp",
          stack: ["mdi-vuejs", "mdi-nodejs", "mdi-database-check-outline"],
        },
        {
          title: "Identicum",
          description: "Website of a cybersecurity company.",
          image: "identicum.png",
          link: "https://identicum.com/",
          github: "https://github.com/Identicum",
          stack: [
            "mdi-language-html5",
            "mdi-language-css3",
            "mdi-language-javascript",
          ],
        },
        {
          title: "ListApp",
          description: "Mobile Android App for home shopping management.",
          image: "logoListApp.jpeg",
          link: "https://github.com/ProyectoFinalGrupo2/ListApp",
          github: "https://github.com/ProyectoFinalGrupo2/ListApp",
          stack: ["mdi-android", "mdi-language-kotlin", "mdi-firebase"],
        },
        {
          title: "Mis Consultas",
          description: "Appointments integral solution for medical offices.",
          image: "misconsultas.png",
          link: "https://misconsultas.netlify.app/#/login",
          github: "https://github.com/valenIndovino/mis-consultas",
          stack: ["mdi-vuejs", "mdi-nodejs", "mdi-database-check-outline"],
        },
        {
          title: "Apuestas Deportivas",
          description: "Personal Project about online sports betting.",
          image: "logo-apuestas.jpeg",
          link: "https://github.com/valenIndovino/apuestas-deportivas",
          github: "https://github.com/valenIndovino/apuestas-deportivas",
          stack: [
            "mdi-dot-net",
            "mdi-language-csharp",
            "mdi-database-check-outline",
          ],
        },
        {
          title: "Dental Care",
          description: "Management system for dental clinic appointments.",
          image: "dentalcare.png",
          link: "https://github.com/christiancdv/dentalcare",
          github: "https://github.com/christiancdv/dentalcare",
          stack: [
            "mdi-dot-net",
            "mdi-language-csharp",
            "mdi-database-check-outline",
          ],
        },
      ],
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
    CardProject,
  },
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
  },
  mounted() {
    const mediaQuery = window.matchMedia("(max-width: 1100px)");

    const handleShow = (e) => {
      if (e.matches) {
        this.show = 1;
        this.autoplay = 0;
        this.transition = "1000";
      } else {
        this.show = 3;
        this.autoplay = 50;
        this.transition = "4000";
      }
    };
    mediaQuery.addEventListener("change", handleShow);
    handleShow(mediaQuery);
  },
});
</script>

<style scoped>
#portfolio {
  padding-bottom: 50px;
  padding-top: 150px;
  background: linear-gradient(
    to top,
    rgb(52 144 103 / 90%),
    rgba(52, 144, 103, 0.783),
    rgb(219, 219, 219),
    rgb(219, 219, 219),
    rgb(234, 234, 234)
  );
}

.carousel__slide {
  padding: 50px;
}

.carousel__viewport {
  perspective: 2000px;
}

.carousel__track {
  transform-style: preserve-3d;
}

.carousel__slide--sliding {
  transition: 0.5s;
}

.carousel__slide {
  opacity: 0.9;
  transform: rotateY(-20deg) scale(0.9);
}

.carousel__slide--active ~ .carousel__slide {
  transform: rotateY(20deg) scale(0.9);
}

.carousel__slide--prev {
  opacity: 1;
  transform: rotateY(-10deg) scale(0.95);
}

.carousel__slide--next {
  opacity: 1;
  transform: rotateY(10deg) scale(0.95);
}

.carousel__slide--active {
  opacity: 1;
  transform: rotateY(0) scale(1.1);
}
</style>
